<template>
    <div class="reservation_single" v-if="!isFetching">
        <div class="reservation_single-back">
            <div class="reservation_single-back--btn" @click="this.$router.go(-1)">
                <div class="icon">
                    <img src="../assets/img/back.svg">
                </div>
                <div class="text">
                    Назад
                </div>
            </div>

        </div>
        <div class="reservation_single-content">
            <div class="reservation_single-content--header">
                <div class="reservation_single-content--title">
                    {{ this.reservation.training_name }}
                </div>

                <template v-if="+this.reservation.cancel">
                    <p class="reservation_item--status canceled">
                      Занятие отменено
                    </p>
                </template>

                <div v-else class="reservation_single-content--status" :class="'reservation_single-content--status-' + this.reservation.status">
                    {{ eventStatus }}
                </div>

                <div class="reservation_single-content--params">
                    <div class="reservation_single-content--date">
                        <ul class="list-style-dot">
                            <li>{{ eventTimeStart }} - {{ eventTimeEnd }}</li>
                            <li>{{ eventDate }}</li>
                        </ul>
                    </div>
                    <div class="reservation_single-content--meta">
                        <ul class="list-style-dot">
                            <li>{{ eventType }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="reservation_single-content--data">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="reservation_single-content--data_block reservation_single-content--trainer">
                            <div class="img">
                                <img :src="eventTrainerPhotoUrl" :alt="eventTrainerName" onerror="this.parentElement.style.display='none'">
                            </div>
                            <div class="name">
                                {{ eventTrainerName }}
                                <div class="position">
                                    {{ eventTrainerPosition }}
                                </div>
                            </div>
                            <div class="rating">
                                <i><img src="../assets/img/star.svg"></i> <span>{{ eventTrainerRating }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="reservation_single-content--data_block reservation_single-content--place">
                            <i>
                                <img src="../assets/img/gantel.svg">
                            </i>
                            {{ this.reservation.place_name }}
                        </div>
                    </div>
                    <div class="col-lg-12" v-if="this.eventGroup !== null">
                        <div class="reservation_single-content--data_block reservation_single-content--icons">
                            <ul>

                                <li v-if="this.eventGroup.payed === 'pay'">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/money.png">
                                        </div>
                                        <div class="text">
                                            Платное
                                        </div>
                                    </div>
                                </li>

                                <li v-if="this.eventGroup.type === 'kids'">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/kids.png">
                                        </div>
                                        <div class="text">
                                            Детское
                                        </div>
                                    </div>
                                </li>

                                <li v-if="this.eventGroup.transfer_event !== null && this.eventGroup.transfer_event !== undefined">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/transfer.png">
                                        </div>
                                        <div class="text">
                                            Перенесено
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="reservation_single-content--description">
                {{ this.reservation.description }}
            </div>

            <div class="reservation_single-content--action" v-if="!isEventFinished">
                <div
                    class="btn btn-white"
                    :class="{disabled: isDisabledBtn}"
                    @click="cancelReservation"
                    v-if="!isReservationCanceled"
                >
                    Отменить тренировку
                </div>

                <div
                    class="btn"
                    :class="{disabled: isDisabledBtn}"
                    @click="addReservation"
                    v-if="isReservationCanceled && this.eventGroup !== null"
                >
                    Записаться на тренировку
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import api from "../api";
    import moment from "moment";

    export default {
        name: 'ReservationSingle',
        data() {
            return {
                reservation: null,
                eventGroup: null,
                trainer: null,
                isFetching: true,
                isDisabledBtn:false,
            }
        },
        computed: {
            eventType: function () {
                return (this.reservation.type === 'group') ? 'Групповая' : 'Персональная'
            },
            eventTrainer: function () {
                return (this.reservation.type !== 'personal' && this.eventGroup.trainer_replacement !== null) ? this.eventGroup.trainer_replacement : this.trainer;
            },
            eventTrainerName: function () {
                return this.eventTrainer.surname + ' ' + this.eventTrainer.name
            },
            eventTrainerPhotoUrl: function (){
                return this.eventTrainer.photo
            },
            eventTrainerPosition: function() {
                return this.eventTrainer.function
            },
            eventTrainerRating: function () {
                return this.eventTrainer.rating
            },
            eventDate: function () {
                return moment(this.reservation.date, 'YYYY-MM-DD').format('dd, D MMMM ');
            },
            eventTimeStart: function () {
                return moment(this.reservation.start, 'HH:mm:ss').format('HH:mm');
            },
            eventTimeEnd: function () {
                return moment(this.reservation.end, 'HH:mm:ss').format('HH:mm');
            },
            eventStatus: function () {
                let status = '';

                switch (Number(this.reservation.status)) {
                    case 0:
                        status = 'Вы записаны'
                        break;
                    case 1:
                        status = 'Вы записаны'
                        break;
                    case 2:
                        status = 'Отказался'
                        break;
                    case 3:
                        status = 'Занятие завершено'
                        break;
                    case 4:
                        status = 'Занятие пропущено'
                        break;
                    case 5:
                        status = 'Поздняя отмена'
                        break;
                    case 7:
                        status = 'Лист ожидания'
                        break;
                    default:
                        status = 'Неизвестно'
                }

                return status
            },
            isEventFinished: function(){
                return moment(this.reservation.date + ' ' + this.reservation.start).isBefore()
            },
            isReservationCanceled: function(){
                return (this.reservation.status === 2 || this.reservation.status === 5)
            }
        },
        methods: {
            async loadEvent(){
                try {
                    this.$store.commit('SHOW_PRELOADER')
                    this.reservation = (await api.schedule.getReservation(this.$route.params.id)).data;
                    this.trainer = (await api.schedule.getTrainer(this.reservation.trainer)).data;

                    if (this.reservation.schedule_id !== null){
                        this.eventGroup = (await api.schedule.getSchedule(this.reservation.schedule_id)).data;
                    }
                    this.$store.commit('HIDE_PRELOADER')
                    this.isFetching = false
                }catch (e) {
                    console.log(e)
                    alert('Ошибка загрузки. Попробуйте еще раз.')
                    this.$store.commit('HIDE_PRELOADER')
                    this.isFetching = false
                }
                this.isDisabledBtn = false;
            },
            async cancelReservation(){
                this.isDisabledBtn = true;
                const result = (await api.schedule.deleteSchedule(this.reservation.id)).data;

                if (result.status == 'success'){
                    this.loadEvent()
                    this.$store.dispatch('loadReservations')
                }
            },
            async addReservation(){
                this.isDisabledBtn = true;
                const result = (await api.schedule.postSchedule(this.reservation.schedule_id)).data;

                if (result.status == 'success' || result.status == 'waiting'){
                    this.loadEvent()
                    this.$store.dispatch('loadReservations')
                }
            }
        },
        beforeCreate() {

        },
        created() {
            this.loadEvent()
        },
        mounted() {

        }
    }
</script>
